import { createTheme } from '@mui/material/styles'

export const AppTheme = createTheme({
  palette: {
    primary: {
      main: '#026AB7',
      dark: '#046CB5',
      light: '#E3F2FD',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Lato, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
        },
      },
    },
  },
})
